import React from 'react'
import styles from './status-badge.module.css';
interface StatusBadgeProps {
    label: string;
    status?: "success" | "error" | "default";
}
export default function StatusBadge(props: StatusBadgeProps) {
  return (
    <div className={styles.root} data-status={props.status || "default"}>
        {props.label}
    </div>
  )
}
